import { useEffect, useState } from "react";

import styles from "./RecoverPasswordForm.module.scss";
import googleIcon from "assets/icons/google-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNewUser } from "service/AdminService";
import { postRegisterUser } from "store/slices/AdminSlice";
import Notification from "utils/Notifications";
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
import { getUserInfo, logintrash, postRecoverPassword, postRecoverPasswordCheckPin, postRecoverPasswordEndProgress } from "service/AuthService";
import { changePinCode, setUser } from "store/slices/UserSlice";
import tokenDecode from "utils/decode";

import { ScaleLoader } from "react-spinners";
import { Button } from "components";
import { gapi } from "gapi-script";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { getImage } from "service/BackgroundService";

import PinCode from "hooks/PinCode/PinCode";
import RecoverCode from "hooks/RecoverCode/RecoverCode";
import {
  checkPinCode,
} from "service/AuthService";
import {
  ChangePin,
  SendDevice,
  login,
} from "service/AuthService";
import { useNavigate } from "react-router-dom";



const RecoverPasswordForm = ({ setRecoverPassword, RecoverPin }) => {
  //UserInfo
  const [loader, setLoader] = useState(false);
  const [pinWindow, setPinWindow] = useState(false);
  const [newPasswordWindow, setNewPasswordWindow] = useState(false);

  const [inn, setInn] = useState(null);
  const [password, setPassword] = useState(null);
  const [checkPassword, setCheckPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);
  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [recoverCode, setRecoverCode] = useState();
  const [userId, setUserId] = useState();
  const [device, setDevice] = useState("");
  //TEST GOOGLE

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);
  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
      console.log("CHU");
      // Handle the case when the socket is not open
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(String(email).toLowerCase());
  };
  //Const & Let
   const pinLogIn = async () => {
  localStorage.setItem("mute", false);

  if (String(pinCode).length === 4) {
    setLoader(true);

    try {
      // вызываем API для проверки ПИНа
      const response = await checkPinCode(pinCode, userId);

      if (response.data.success) {
        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
        });

        const socket = new WebSocket("wss://sys.chu.kg/ws/online_status/");
        socket.onopen = () => {
          socket.send(JSON.stringify({ command: "connect", user_id: userId }));
          socket.close();
        };

        let response2 = await SendDevice(device);

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));

        setTimeout(() => {
          window.location.href = `/home/`;
        }, 1000);

      } else {
        setNotify({
          isOpen: true,
          message: "Неправильный Пин-Код",
          type: "error",
          sound: "error",
        });
      }
    } catch (error) {
      setNotify({
        isOpen: true,
        message: "Ошибка сервера. Попробуйте позже.",
        type: "error",
        sound: "error",
      });
    } finally {
      setLoader(false);
    }

  } else {
    setNotify({
      isOpen: true,
      message: "Введите 4-значный ПИН-код",
      type: "warning",
    });
  }
};

  const createUserPin = async () => {

    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: "Введите Пин!",
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        let response = await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: "Пин успешно задан",
            type: "success",
            sound: "success",
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
          sound: "success",
        });
        setTimeout(async () => {


          // let response4 = await getTariffSubscription(datainfo);
         
          // localStorage.setItem(
          //   "subscription_title",
          //   JSON.stringify(response4.data.subscription[0].tariff.title)
          // );
        
          let response2 = await SendDevice(device);

          setUserId(datainfo.user);
          sendMessage({ user_id: userId });
          dispatch(setUser(datainfo));
          setTimeout(() => {

            navigate(`/home/`);
          }, 2000);
        }, 1000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: "Ошибка",
          type: "error",
          sound: "error",
        });
      }
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      inn === null
    ) {
      setNotify({
        isOpen: true,
        message: "Введите свой ИИН!",
        type: "warning",
        sound: "warning",
      });
    }
    else if (inn.length < 5) {
      setNotify({
        isOpen: true,
        message: "ИНН слишком короткий",
        type: "warning",
        sound: "warning",
      });
    } else
      try {
        setLoader(true);
        let emailtrash = "free";
        let passwordtrash = "free";
        let responsed = await logintrash(emailtrash, passwordtrash);
        localStorage.setItem("token", responsed.data.access);
        const userIdd = tokenDecode(responsed.data.refresh);
        let userResponsed = await getUserInfo(userIdd);
        const datas = { ...userResponsed.data, token: responsed.data.access };

        dispatch(setUser(datas));

        let response = await postRecoverPassword(
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            setPinWindow(true)
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {
        console.log("CHU");

        setNotify({
          isOpen: true,
          message: "Ошибка!",
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
  const handleSubmitCode = async (event) => {
    event.preventDefault();
    if (String(recoverCode)?.length < 6 || !recoverCode) {
      setNotify({
        isOpen: true,
        message: "Введите Пин!",
        type: "error",
        sound: "error",
      });
    } else
      try {
        setLoader(true);
        let emailtrash = "free";
        let passwordtrash = "free";
        let responsed = await logintrash(emailtrash, passwordtrash);
        localStorage.setItem("token", responsed.data.access);
        const userIdd = tokenDecode(responsed.data.refresh);
        let userResponsed = await getUserInfo(userIdd);
        const datas = { ...userResponsed.data, token: responsed.data.access };

        dispatch(setUser(datas));

        let response = await postRecoverPasswordCheckPin(
          recoverCode,
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            setPinWindow(false)
            setNewPasswordWindow(true)
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {
        console.log("CHU");

        setNotify({
          isOpen: true,
          message: "Ошибка!",
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
  const handleSubmitEndProgress = async (event) => {
    event.preventDefault();
    if (password === null) {
      setNotify({
        isOpen: true,
        message: "Введите новый пароль!",
        type: "error",
        sound: "error",
      });
    } else if (checkPassword !== password) {
      setNotify({
        isOpen: true,
        message: "Пароли не совпадают!",
        type: "warning",
        sound: "warning",
      });
    } else
      try {
        setLoader(true);
        let emailtrash = "free";
        let passwordtrash = "free";
        let responsed = await logintrash(emailtrash, passwordtrash);
        localStorage.setItem("token", responsed.data.access);
        const userIdd = tokenDecode(responsed.data.refresh);
        let userResponsed = await getUserInfo(userIdd);
        const datas = { ...userResponsed.data, token: responsed.data.access };

        dispatch(setUser(datas));

        let response = await postRecoverPasswordEndProgress(
          password,
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            const delay = 1000; 
            setTimeout(() => {
              
              // setLoginMail(false);
              const signIn = async (event) => {
                localStorage.removeItem("task");
                localStorage.removeItem("user");
                let responseinfo = await login(inn, password);
             
                localStorage.setItem("token", responseinfo.data.access);
                const userId = tokenDecode(responseinfo.data.refresh);
      
                let userResponse =  await getUserInfo(userId);
                const data = { ...userResponse.data, token: responseinfo.data.access };
           
                //урезал код
                setUserPinCode(data.pin);
                setDataInfo(data)
                setOpenModal(true);
                setUserId(userId);
            
            };
            signIn()
            }, delay);
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {
        console.log("CHU");

        setNotify({
          isOpen: true,
          message: "Ошибка!",
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
  const forSelect = useSelector((state) => state.order.position);

  //Consts & Let
  const dataRector = [forSelect];
  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d]/g, '');

    setInn(value);

  };
  const [isError, setIsError] = useState(false);


  return (
    <>
      <div className={styles.container}>
       
        <h2 className={styles.login__title}>Восстановление пароля! 👋🏻</h2>

        {pinWindow === false ? (
          newPasswordWindow === false ? (
            <>
              <h4 className={styles.login__untitle}>Введите свой ИНН, код для сброса пароля будет отправлен вам на электронную почту!</h4>
              <form action="#">
                <div className={styles.user_details}>
                  <div className={styles.input_pox} style={{ width: '100%' }}>
                    <span className={styles.datails}>ИНН</span>
                    <input
                      type="number"
                      placeholder="ИНН"
                      value={inn}
                      onChange={handleInputChange}
                      required
                    />
                  </div>



                </div>

                {loader ? (
                  <ScaleLoader color="black" size={30} />
                ) : (
                  <div className={styles.button}>


                    <input
                      type="submit"
                      onClick={handleSubmit}
                      value="Получить код"
                    />

                  </div>
                )}
              </form>

              <h4 className={styles.login__untitle} style={{ marginTop: "10px" }}>Если у вас не указана электронная почта, обратитесь в службу поддержки по номеру <b>0777404312</b>.</h4>
            </>
          ) : (
            <>
              <h4 className={styles.login__untitle}>Пожалуйста, придумайте новый пароль!</h4>
              <form action="#">
                <div className={styles.user_details}>
                  <div className={styles.input_pox} style={{ width: '100%' }}>
                    {/* <span className={styles.datails}>ИНН</span> */}
                    <input
                      style={{ backgroundColor: "#ebebeb" }}
                      type="text"
                      placeholder="ИНН"
                      value={inn}
                      readOnly={true}
                    />
                  </div>
                  <div className={styles.input_pox}>
              <span className={styles.datails}>Новый пароль</span>

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                
              />
              <div src={eye} type="button" className={styles.show__password} onClick={togglePasswordVisibility}>
                {showPassword ? <> <img src={hidden}></img> </> : <> <img src={eye}></img> </>}
              </div>
            </div>
            <div className={styles.input_pox}>
          
              <span className={styles.datails}>Повторите пароль</span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Пароль"
                value={checkPassword}
                onChange={(e) => setCheckPassword(e.target.value)}
                required
              />
             
            </div>
                  <div style={{ width: '100%', paddingBottom: "20px" }}>

                  </div>
                </div>

                {loader ? (
                  <ScaleLoader color="black" size={30} />
                ) : (
                  <div className={styles.button}>


                    <input
                      type="submit"
                      onClick={handleSubmitEndProgress}
                      value="Войти"
                    />

                  </div>
                )}
              </form>
            </>
          )
        ) : (

          <>
            <h4 className={styles.login__untitle}>Введите код, отправленный вам на электронную почту!</h4>
            <form action="#">
              <div className={styles.user_details}>
                <div className={styles.input_pox} style={{ width: '100%' }}>
                  {/* <span className={styles.datails}>ИНН</span> */}
                  <input
                    style={{ backgroundColor: "#ebebeb" }}
                    type="number"
                    placeholder="ИНН"
                    value={inn}
                    readOnly={true}
                  />
                </div>
                <div style={{ width: '100%', paddingBottom: "20px" }}>
                  <RecoverCode setRecoverCode={setRecoverCode} passwordVisible={false} />
                </div>
              </div>

              {loader ? (
                <ScaleLoader color="black" size={30} />
              ) : (
                <div className={styles.button}>


                  <input
                    type="submit"
                    onClick={handleSubmitCode}
                    value="Отрпавить"
                  />

                </div>
              )}
            </form>
          </>

        )}
        <hr className={styles.hr__line}></hr>

        <div className={styles.register_footer}>
          Вы помните пароль?

          <button
            className={styles.register_button}
            onClick={() => setRecoverPassword(false)}
          >
            Войти
          </button>


        </div>
      </div>

      <Notification notify={notify} setNotify={setNotify} />
      {userPinCode === null ? (
        <>
          <ModalWindow
            openModal={openModal}
            setOpenModal={setOpenModal}
            modalTitle={
              <>
                <p>
                  Добро пожаловать!
                </p>
              </>
            }
            modalText={"Придумайте ПИН-код"}
            width={"unset"}
          >
            <PinCode setPinCode={setPinCode} passwordVisible={false} />

            {loader ? (
              <Button
                style={{ width: "unset", border: "none", background: "none" }}
              >
                <ScaleLoader color="black" size={15} />
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => setOpenModal(false)}
                  className={styles.btn_pin_close}
                >
                  Закрыть
                </Button>
                <Button
                  style={{ width: "unset" }}
                  onClick={createUserPin}
                  className={styles.btn_pin}
                >
                  Сохранить
                </Button>
              </>
            )}
          </ModalWindow>{" "}
        </>
      ) : (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={"Введите ПИН-код"}
          width={"unset"}
        >
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {" "}
              Закрыть
            </Button>
            <Button onClick={pinLogIn} className={styles.btn_pin}>
              Войти
            </Button>
          </>
          <div className={styles.div_register_button} style={{marginTop:'5px'}}>
          <p
              className={styles.register_button_reset}
              onClick={() => RecoverPin()}
              style={{ margin: "0px 10px 0px 0" }}
            >
              Забыли пин?
              {/* <img src={rostok} className={styles.size} alt="" /> */}
            </p>
      </div>
        </ModalWindow>
      )}
    </>
  );
};

export default RecoverPasswordForm;
